export const TYPING_INDICATOR_INTERVAL = 5000;
export const BOT_TYPING_INTERVAL = 2000;
export const MESSAGE_READ_INTERVAL = 2000;

export const MAX_IMAGE_SIZE = 15; // 15MB
export const MAX_VIDEO_SIZE = 100; // 100MB
export const MAX_FILE_COUNT = 8;

export const MESSAGE_UNREAD_TEXT = 'New';
export const RESTART_POPUP_MESSAGE =
  'The link used to start Alex is no longer valid. Would you like to start a new conversation?';

export const WEWEB_STAGING_URL =
  'https://c7b69f12-6e9f-4f5d-a085-09b044133d3e-staging.weweb.io';
export const OC_DEV_URL = 'https://dev-jrc-rh-botplugin.azureedge.net';

export enum BotMessageType {
  TYPING = 'Typing',
  REDIRECT = 'Redirect',
  SET_ATTRIBUTE = 'Set Attribute',
  INPUT = 'Input',
  PLUGIN = 'Plugin',

  //Custom Type - Use only for FE
  REMOVE_TYPING = 'RemoveTyping',
}

export enum AgencyType {
  RH = 'rh',
  NONE = 'none',
}

export enum UserMessageType {
  TEXT = 'Text',
  BUTTON = 'Button',
  ATTACHMENTS = 'Attachments',
}

export enum RealtimeMessageType {
  BOT_MESSAGE_NEW = 'bot_channel_message_new',
}

export enum IframeMessageType {
  RESTART_CHAT = 'iframe_restart_chat',
  SET_SESSION_ID = 'iframe_set_session_id',
  LOAD_PREVIOUS_CONVERSATION = 'iframe_load_previous_conversation',
  NEW_MESSAGE_NOTIFICATION = 'iframe_new_message_notification',
}
